// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@gcg/XDL/types";

import { screen } from "@gcg/XDL/Helpers";
import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            drawerContainer: css`
                ${screen("gt", "md")`
                    > div > div {
                        max-width: 1440px;
                        padding-left: 10px;
                        padding-right: 10px;
                        margin: 0 auto;
                        width: 100%;
                    }

                    #drawerTitle {
                        padding-top: 20px;
                    }
                `}
                #drawerTitle {
                    > button {
                        padding: 0;
                        &:hover {
                            background: ${getColor("common.white")};
                            border-color: ${getColor("common.white")};
                        }
                    }
                }
            `,
        },
    },
} as xBaseTheme["drawer"];
